import { render, staticRenderFns } from "./TruckDetailView.vue?vue&type=template&id=b3281260"
import script from "./TruckDetailView.vue?vue&type=script&lang=js"
export * from "./TruckDetailView.vue?vue&type=script&lang=js"
import style0 from "./TruckDetailView.vue?vue&type=style&index=0&id=b3281260&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports